import React from 'react';
import Icon from '../../../components/AppIcon';

const milestones = [
  { phase: 'Project Approval', icon: 'FileText', status: 'completed', date: 'Jan 2023', description: 'Master developer approval and land allocation from DLD', docs: ['Master Plan Approval', 'Land Allocation Certificate'] },
  { phase: 'RERA Registration', icon: 'Shield', status: 'completed', date: 'Mar 2023', description: 'Developer RERA license and project registration with escrow setup', docs: ['RERA Developer License', 'Project Registration Certificate'] },
  { phase: 'Construction Permit', icon: 'Building2', status: 'completed', date: 'Jun 2023', description: 'Dubai Municipality construction permit and engineering approvals', docs: ['Construction Permit', 'Engineering Approval'] },
  { phase: 'Sales Launch', icon: 'TrendingUp', status: 'completed', date: 'Aug 2023', description: 'RERA sales authorization and SPA template approval', docs: ['Sales Authorization', 'SPA Template'] },
  { phase: 'Construction Phase', icon: 'Hammer', status: 'active', date: 'Ongoing', description: 'Active construction with quarterly RERA progress reports', docs: ['Q1 2025 Progress Report', 'Escrow Audit Report'] },
  { phase: 'Completion Certificate', icon: 'Award', status: 'pending', date: 'Q3 2026', description: 'Dubai Municipality completion certificate and RERA handover approval', docs: ['Completion Certificate', 'Handover Approval'] },
  { phase: 'Title Deed Issuance', icon: 'Key', status: 'pending', date: 'Q4 2026', description: 'DLD title deed issuance and ownership transfer to buyers', docs: ['Title Deed', 'Ownership Transfer'] }
];

const statusStyles = {
  completed: { color: '#22c55e', bg: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.4)', line: '#22c55e' },
  active: { color: '#00D4FF', bg: 'rgba(0,212,255,0.15)', border: 'rgba(0,212,255,0.5)', line: '#00D4FF' },
  pending: { color: '#6B9EC4', bg: 'rgba(107,158,196,0.08)', border: 'rgba(107,158,196,0.2)', line: 'rgba(107,158,196,0.3)' }
};

const ComplianceTimeline = () => (
  <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
    <div className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
        <Icon name="GitBranch" size={20} color="#00D4FF" />
      </div>
      <div>
        <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Regulatory Compliance Timeline</h3>
        <p className="text-xs" style={{ color: '#6B9EC4' }}>From project approval to handover — all regulatory milestones</p>
      </div>
    </div>

    <div className="relative">
      {milestones?.map((m, i) => {
        const s = statusStyles?.[m?.status];
        return (
          <div key={i} className="flex gap-4 mb-4 last:mb-0">
            <div className="flex flex-col items-center">
              <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: s?.bg, border: `2px solid ${s?.border}` }}>
                <Icon name={m?.icon} size={16} color={s?.color} />
              </div>
              {i < milestones?.length - 1 && (
                <div className="w-0.5 flex-1 mt-1" style={{ background: s?.line, minHeight: 20 }} />
              )}
            </div>
            <div className="flex-1 pb-4">
              <div className="flex items-center justify-between flex-wrap gap-1 mb-1">
                <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{m?.phase}</span>
                <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: s?.bg, color: s?.color }}>
                  {m?.status === 'completed' ? '✓ Complete' : m?.status === 'active' ? '● In Progress' : '○ Upcoming'}
                </span>
              </div>
              <p className="text-xs mb-2" style={{ color: '#6B9EC4' }}>{m?.description}</p>
              <div className="flex flex-wrap gap-1">
                {m?.docs?.map((doc, j) => (
                  <span key={j} className="text-xs px-2 py-0.5 rounded" style={{ background: 'rgba(0,212,255,0.06)', border: '1px solid rgba(0,212,255,0.15)', color: '#00D4FF' }}>{doc}</span>
                ))}
              </div>
              <div className="text-xs mt-1" style={{ color: '#6B9EC4' }}>📅 {m?.date}</div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);

export default ComplianceTimeline;
